import React, { FC, useEffect, useRef } from "react";
import { createRoot, Root } from "react-dom/client";

import { useStoreLocator } from "../../../../hooks/use-store-locator";
import { CompanySiteType } from "../../../../types/company-site";
import { StoreIcon } from "../store-icon";

type AdvancedMarkerElement = google.maps.marker.AdvancedMarkerElement;

export interface StoreLocatorMarkerProps {
  store: Queries.CompanySiteDetailDataFragment;
  position: google.maps.LatLngLiteral;
}

export const StoreLocatorMarker: FC<StoreLocatorMarkerProps> = ({ position, store }) => {
  const { map, setSelectedStoreId } = useStoreLocator();
  const markerRef = useRef<AdvancedMarkerElement>();
  const rootRef = useRef<Root>();

  useEffect(() => {
    if (!rootRef.current) {
      const container = document.createElement("div");
      rootRef.current = createRoot(container);
      const marker = new google.maps.marker.AdvancedMarkerElement({
        position,
        content: container,
      });
      // without this, it will prevent the click on the actual marker content
      marker.addListener("click", () => void 0);
      markerRef.current = marker;
    }
  }, [position, store]);

  useEffect(() => {
    if (!markerRef.current || !rootRef.current || !store.siteType) return;
    rootRef.current.render(
      <StoreIcon
        type={store.siteType as CompanySiteType}
        id={store.id}
        onClick={() => setSelectedStoreId(store.id)}
      />
    );
    markerRef.current.position = position;
    markerRef.current.map = map;

    return () => {
      if (markerRef.current) {
        markerRef.current.map = null;
      }
    };
  }, [map, position, store, setSelectedStoreId]);

  return null;
};
